import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for ViewLifecycleStore, for use in the registry */ // ToDo: add FetchBasicDeltaSyncFeedFailedAction
export const ViewLifecycleStoreActionTypes = [
    ActionType.NavigateToView,
    ActionType.ViewDataFetchAction,
    ActionType.ViewForceDataFetchAction,
    ActionType.DeltaSyncFailedAction
];
